<template>
  <div v-if="group.items.length" class="app-data-filter__group">
    <AppDataFilterRadioGroupItem
      v-for="(item, i) in group.items"
      :key="`${group.itemsType}-radio${i}`"
      v-model="checkedValue"
      :item="item"
      @change="onChange"
    />
  </div>
</template>

<script>
import { isObject } from '@/helpers/common';
import { getItemValueAsScalar } from '@/helpers/data-filter/utils';
import AppDataFilterRadioGroupItem from './AppDataFilterRadioGroupItem';

export default {
  name: 'AppDataFilterRadioGroup',
  components: { AppDataFilterRadioGroupItem },
  props: {
    group: {
      type: Object,
      default: () => ({
        items: [],
        itemsType: '',
      }),
    },
    value: {
      type: [String, Number, Boolean, Object],
      default: null,
    },
  },

  data() {
    return {
      checkedValue: null,
    };
  },

  computed: {
    realCheckedValue() {
      const itemResult = this.group.items.find((item) => this.checkedValue === getItemValueAsScalar(item));

      return itemResult ? itemResult.value : null;
    },
  },

  watch: {
    value: {
      handler(newVal, oldVal) {
        const oldValue = isObject(oldVal) ? oldVal._filter : oldVal;
        const newValue = isObject(newVal) ? newVal._filter : newVal;

        if (newValue !== oldValue) {
          this.checkedValue = newValue;
        }
      },
      immediate: true,
    },
  },

  methods: {
    onChange() {
      this.$emit('update', this.realCheckedValue);
    },
  },
};
</script>
